import { render, staticRenderFns } from "./crud.vue?vue&type=template&id=37c7dcad&scoped=true&"
import script from "./crud.vue?vue&type=script&lang=js&"
export * from "./crud.vue?vue&type=script&lang=js&"
import style0 from "./crud.vue?vue&type=style&index=0&id=37c7dcad&prod&lang=css&"
import style1 from "./crud.vue?vue&type=style&index=1&id=37c7dcad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c7dcad",
  null
  
)

export default component.exports